import { Routes, Route } from "react-router-dom";
import Home from "../Pages/Home/Home";
import About from "../Pages/About";
import Products from "../Pages/Products";
import Blog from "../Pages/Blog/Index";
import Notice from "../Pages/Notice";

export default function BrowseRoutes() {
	return (
		<Routes>
			<Route path="/" element={<Home />} />
			<Route path="/quemsomos" element={<About />} />
			<Route path="/produtos" element={<Products />} />
			<Route path="/blog" element={<Blog />} />
			<Route path="/blog/notice/:id" element={<Notice />} />
		</Routes>
	);
}
